import {
  BorderProps,
  SpindlLogoProps,
} from 'spindl-shared-components';
import { AccountMenuDropDownProps } from '../../molecules/AccountMenuDropDown';
import { AppDropDownProps } from '../../molecules/AppDropDown';

type TopNavInternalProps = {
  spindlLogo?: SpindlLogoProps;
  border?: BorderProps;
  appDropDown?: AppDropDownProps;
  accountMenuDropDown?: AccountMenuDropDownProps;
  border1?: BorderProps;
};

type TopNavPropsValues = {
  '': TopNavInternalProps;
};

const propValues: TopNavPropsValues = {
  '': {
    spindlLogo: {
    },
    border: {
      colour: 'Dark',
      type: 'Vertical',
      styleType: 'Default',
    },
    appDropDown: {
      state: 'Collapsed',
    },
    accountMenuDropDown: {
      state: 'Collapsed',
    },
    border1: {
      colour: 'Dark',
      type: 'Horizontal',
      styleType: 'Default',
    },
  },
};

const getProps = (type: string): TopNavInternalProps => {
  const values: TopNavInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
